import React from 'react';
import { FaWhatsapp } from "react-icons/fa";
import { FaPhoneAlt } from 'react-icons/fa';
import { CONTACT_INFO } from '../config/constants';

export default function FloatingContactButtons() {

  const phone = CONTACT_INFO.mainPhone;
  const whatsapp = CONTACT_INFO.mainWhatsappLink;

  return (
    <div className="fixed bottom-6 right-4 flex flex-col space-y-4 md:hidden z-50">
      {/* Phone Button */}
      <a
        href={`tel:${phone}`}
        className="w-14 h-14 rounded-full bg-sky-600 hover:bg-sky-700 shadow-lg flex items-center justify-center text-white text-2xl transition"
        aria-label="Call Ambulance"
        title="Call Ambulance"
      >
        <FaPhoneAlt className="text-white text-xl" />
      </a>

      {/* WhatsApp Button */}
      <a
        href={whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg flex items-center justify-center text-white text-2xl transition"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
      >
         <FaWhatsapp className="text-white text-2xl" />
      </a>
    </div>
  );
}
